export enum EntitlementActorType {
  BOATER = 'BOATER',
  HARBOR = 'HARBOR',
  CLUB = 'CLUB',
  DMO = 'DMO',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
}

export enum EntitlementGrantType {
  TRIAL = 'TRIAL',
  PROMO = 'PROMO',
  PARTNER = 'PARTNER',
  MANUAL = 'MANUAL',
}

export enum EntitlementGrantStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}

export enum SubscriptionPlanLevel {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
}

export interface EntitlementGrant {
  id: string;
  actor_type: EntitlementActorType;
  actor_id: string;
  actor_name: string | null;
  grant_type: EntitlementGrantType;
  capability_level: SubscriptionPlanLevel | null;
  start_at: string;
  end_at: string;
  status: EntitlementGrantStatus;
  source: string | null;
  reference_subscription_id: string | null;
  subscription_name: string | null;
  created_by: string | null;
  created_by_name: string | null;
  cancelled_at: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export interface EntitlementGrantListResponse {
  status: boolean;
  message: string;
  data: EntitlementGrant[];
  total: number;
  page: number;
  limit: number;
}

export interface EntitlementGrantResponse {
  status: boolean;
  message: string;
  data: EntitlementGrant;
}

export interface CreateEntitlementGrantPayload {
  actor_type: EntitlementActorType;
  actor_id: string;
  grant_type: EntitlementGrantType;
  start_at: string;
  end_at: string;
  reference_subscription_id: string;
}

export interface UpdateEntitlementGrantPayload {
  status?: EntitlementGrantStatus.CANCELLED;
  end_at?: string;
}

export interface ListEntitlementGrantsParams {
  page?: number;
  limit?: number;
  search?: string;
  actor_type?: EntitlementActorType;
  actor_id?: string;
  grant_type?: EntitlementGrantType;
  status?: EntitlementGrantStatus;
  start_from?: string;
  start_to?: string;
}
